/* eslint-disable */
import { useEffect } from 'react';
import { getLoggedInUserData } from './Helper';
import usePractice from '../hooks/usePractice';
import { countryStore, cellStore } from './SharedData';

const CommonAPIUtils = () => {
  const user = getLoggedInUserData();
  if (user == null) {
    return;
  }
  const { getCountry, fetchAllCellList } = usePractice();

  useEffect(() => {
    const fetchData = async () => {
      const country = await getCountry();
      const cell = await fetchAllCellList();
      countryStore(country?.usersResult);
      cellStore(cell?.usersResult);
    };

    fetchData();
  }, []);

  return null;
};

export default CommonAPIUtils;
